import React from 'react';
import { Accordion, Modal } from 'react-bootstrap';
import * as Bs from 'react-icons/bs';

const initialState = {
  isShow: false,
};

const Tutorial = () => {
  const [{ isShow }, setState] = React.useState(initialState);

  const clearState = () => {
    setState({ ...initialState });
  };

  const $handleClose = () => {
    clearState();
  };

  return (
    <>
      <div className="d-flex align-items-center py-2">
        <Bs.BsInfoCircleFill size={20} color="#2f83ba" className="me-2" />
        <span>
          Tambahkan skema kurir.{' '}
          <span
            className="fw-bold text-primary ms-1 text-decoration-underline cursor-pointer"
            onClick={() =>
              setState((prevState) => ({ ...prevState, isShow: true }))
            }
          >
            Pelajari Skema Kurir
          </span>
        </span>
      </div>

      <Modal show={isShow} onHide={$handleClose} centered size="md">
        <Modal.Header className="text-center d-block p-0" closeButton>
          <div className="py-3">
            <div className="fw-bold fs-6">Pelajari Skema Kurir</div>
          </div>
        </Modal.Header>
        <Modal.Body className="px-2 py-3">
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header className="pb-2">
                <div className="fs-6 fw-semibold">Apa fungsi Skema Kurir ?</div>
              </Accordion.Header>
              <Accordion.Body className="px-3 py-2 border-bottom">
                Untuk menambahkan data driver yang dimiliki oleh perusahaan
                dalam mengirim barang dan juga data driver dari vendor armada
                perusahaan.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header className="py-2">
                <div className="fs-6 fw-semibold">
                  Bagaimana cara membuat/menambahkan Skema Kurir ?
                </div>
              </Accordion.Header>
              <Accordion.Body className="px-3 py-2 border-bottom">
                <div className="mb-2">
                  Untuk menambahkan skema kurir baru, ikuti langkah-langkah
                  berikut :
                </div>

                <ol>
                  <li className="mb-2">Tekan tombol Tambah Skema.</li>
                  <li className="mb-2">
                    Setelah itu akan muncul form data skema.
                  </li>
                  <li className="mb-2">Lengkapi data yang diperlukan.</li>
                  <li className="mb-2">
                    Jika data telah terisi dengan benar, maka tekan tombol
                    Simpan untuk menyimpan data.
                  </li>
                </ol>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Tutorial;
